import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed } from "vue";
import { useApiStore, type Team } from "@/stores/api";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const apiStore = useApiStore();

const team: Ref<Team[]> = ref([]);

apiStore.getTeam().then((t: Team[]) => (team.value = t));

const __returned__ = { apiStore, team }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})